<h1 mat-dialog-title>Sezon</h1>
<div mat-dialog-content>
	<div class="mb-6">
		<div class="mb-3">
			{{ data.city1 }}
			<ng-template let-data> Hello, {{ data }} </ng-template>
		</div>
		<div class="float-end" mat-dialog-actions>
			<!-- <button color="warn" mat-raised-button>Zamknij</button> -->
		</div>
	</div>
</div>
